import { useNavigate } from "react-router-dom";
import { Button } from "src/components/buttons/shadcn-button";
import moment from "moment";
import AttendanceChart from "src/components/ui/AttendanceCharts";
import { useTodayAttendance } from "./Attendance/hooks/useFetchTodayAttendance";
import { useSummary } from "./Attendance/hooks/useSummary";

export interface AttendanceStats {
  leaves_pending: number;
  present_today: number;
  total_employee: number;
}

const HrDashboard = () => {
  const navigate = useNavigate();

  const { data } = useTodayAttendance();
  const { data: total, isLoading } = useSummary();

  const present = data?.present_today;
  const absent = data?.absent_today;
  const half_day = data?.half_day_today

  return (
    <div>
      <div className="flex items-center justify-between">
        <h1 className="text-black text-2xl font-semibold">Overview</h1>
        <Button
          className="bg-primary text-foreground rounded-lg hover:bg-accent hover:shadow-lg transition-colors  duration-100 ease-in-out"
          onClick={() => navigate("/admin")}
        >
          Home
        </Button>
      </div>

      {/* Overview Section */}
      <div className="mt-6 grid grid-cols-3 gap-6">
        {/* Total Employees */}
        <div className="bg-white rounded-lg p-5 shadow-lg">
          <h2 className="text-gray-600 font-medium">Total Employees</h2>
          <p className="text-3xl font-bold mt-2">{isLoading ? "--" : total?.total_employee}</p>
          <p className="text-sm text-gray-500">
            Active employees across all locations
          </p>
        </div>

        <div className="bg-white rounded-lg p-5 shadow-lg">
          <h2 className="text-gray-600 font-medium">
            Total Number of Employess present today
          </h2>
          <p className="text-3xl font-bold mt-2">{ isLoading ? "--" : total?.present_today}</p>
          <p className="text-sm text-gray-500">
            {moment().format("MMM Do YY")}
          </p>
        </div>

        <div className="bg-white rounded-lg p-5 shadow-lg">
          <h2 className="text-gray-600 font-medium">Pending Leaves</h2>
          <p className="text-3xl font-bold mt-2">{ isLoading ? "--" : total?.leaves_pending}</p>
          <p className="text-sm text-gray-500">Awaiting manager approvals</p>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="mt-6 grid grid-cols-3 gap-6">
        {/* Attendance Charts */}
        <div className="col-span-2 ">
          <AttendanceChart present={ present ?? 0} absent={ absent ?? 0} halfDay={half_day ?? 0} />
        </div>

        {/* Quick Actions */}
        <div className="bg-white rounded-lg p-5 shadow-lg h-fit">
          <h2 className="text-lg font-semibold mb-4">Quick Actions</h2>
          <div className="flex flex-col gap-3">
            <button
              className="bg-accent text-foreground px-4 py-2 rounded-lg hover:bg-primary"
              onClick={() => navigate("/hr/employees")}
            >
              Add Employee
            </button>

            <button
              className="bg-accent text-foreground px-4 py-2 rounded-lg hover:bg-primary"
              onClick={() => navigate("/hr/attendance")}
            >
              Mark Attendance
            </button>

            <button
              className="bg-accent text-foreground px-4 py-2 rounded-lg hover:bg-primary"
              onClick={() => navigate("/hr/leave-management")}
            >
              Approve Leaves
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HrDashboard;
